let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5LRum")).then(() => parcelRequire('6gJ9X'));